import { getCurrency, getLocaleParts, getValidLocaleISO } from 'utils';
import { getPayPalExpressLocale } from '../utils/paypal-express/getPayPalExpressLocale';

// Both injected at runtime by k8s — no stage detection needed in code.
const PAYPAL_CLIENT = process.env['NEXT_PUBLIC_PAYPAL_CLIENT_ID'] ?? '';
const PAYPAL_MERCHANT = process.env['NEXT_PUBLIC_PAYPAL_MERCHANT_ID'] ?? '';

const locale = getValidLocaleISO(process.env['NEXT_PUBLIC_LOCALE']);
const { countryCode } = getLocaleParts(locale);

export const PAYPAL_EXPRESS_SDK =
  'https://www.paypal.com/sdk/js' +
  `?client-id=${PAYPAL_CLIENT}` +
  `&merchant-id=${PAYPAL_MERCHANT}` +
  '&intent=authorize' +
  `&currency=${getCurrency(countryCode).code}` +
  `&locale=${getPayPalExpressLocale(locale)}` +
  '&disable-funding=giropay,sofort,sepa,card';

export const PAYPAL_ERROR_CODES = {
  // API contract from payment-service — the error code returned in the 422 response body.
  // Distinct from CartDialogType 'PAYPAL_INVALID_SHIPPING_ADDRESS', which is the internal UI state.
  INVALID_ADDRESS: 'PAYPAL_INVALID_ADDRESS',
} as const;
